module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("A heartfelt thanks to those whose advice and expertise proved invaluable while I was writing this book: Michael Barrett, Jane Dystel, David Goldner, Ruth Harris, Ann LaFarge, Bob Patent, and Edwin Shmerler.")]), _vm._v(" "), _c('p', [_vm._v("Special gratitude to my husband, Michael, and to my family and friends, who cheered me on and made me feel that I wasn’t in over my head.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 69
// module chunks = 0